var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1024 232",
  style: {
    enableBackground: "new 0 0 1024 232"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill:#FFFFFF;}\n\t.st1{fill:#E51936;}\n\t.st2{fill:#70CBD2;}\n\t.st3{fill:#5A2049;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M253.9,80.6h20.5v76.7h-20.5V80.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M315.6,80.6h20.5v59.5h32.6v17.3h-53.2V80.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M379.2,119c0-23.1,19.1-39.3,41.2-39.3s41.2,16.1,41.2,39.3s-19.1,39.4-41.2,39.4S379.2,142.1,379.2,119z  M440.6,119c0-12.1-7.3-21.4-20.2-21.4c-12.9,0-20.2,9.4-20.2,21.4c0,12.1,7.3,21.6,20.2,21.6C433.3,140.6,440.6,131.1,440.6,119z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M504.4,158.2c-0.3,0.7-1,0.7-1.4,0L467,80.6h21.9l15.7,35.8l15.2-35.8h20.9L504.4,158.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M554.6,80.6h53.8v17.3h-33.3v17.8h27.8v16.4h-27.8v8H610v17.3h-55.4V80.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M677,157.4h-20.5V80.6h29.1c20.7,0,32.3,13.1,32.3,30.1s-11.6,30-32.3,30H677V157.4z M684.6,123.4 c9.3,0,12.6-5.2,12.6-12.6S693.9,98,684.6,98H677v25.4H684.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M735,80.6h20.5v76.7H735V80.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M770.1,156.2l34-58.4h-28.2V80.6h59.7c0.7,0,0.9,0.2,0.3,1.1l-34,58.4h31.2v17.3h-62.6 C769.8,157.4,769.6,157.1,770.1,156.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M846.9,156.2l34-58.4h-28.2V80.6h59.7c0.7,0,0.9,0.2,0.3,1.1l-34,58.4h31.2v17.3h-62.6 C846.5,157.4,846.3,157.1,846.9,156.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M943.1,157.4H923l37.4-78.1c0.3-0.8,1-0.8,1.4,0l37.2,78.1h-21.2l-2.9-6.5c0.1,0-28.9,0-28.9,0L943.1,157.4z  M960.2,117.6l-7.7,17.8h15.6L960.2,117.6z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M186.7,88.4L186.7,88.4c0.3-17.8-9.7-32.5-25.7-37.6c-1.1-0.4-2.3-0.7-3.4-0.9c-2.7-0.6-5.5-0.9-8.3-0.9 c-13-8.4-28-12.9-43.5-12.9c-24.1,0-46.5,10.6-61.8,29.3h-1.5c-7.1,0-12.9,5.8-12.9,13c0,2.6,0.8,5.2,2.3,7.3 c-4,9.6-6,19.8-6,30.3c0,5.9,0.7,11.8,2,17.6c-3,2.5-4.8,6.3-4.8,10.2c0,7.3,6,13.3,13.3,13.3h1c14.4,24,40.4,38.7,68.5,38.7 c44.1,0,79.9-35.8,79.9-79.9c0-4.8-0.4-9.7-1.3-14.4c0.1-0.3,0.2-0.6,0.3-0.9C186,96.8,186.7,92.6,186.7,88.4z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M30.6,116c0-41.6,33.7-75.3,75.3-75.3c41.6,0,75.3,33.7,75.3,75.3c0,41.6-33.7,75.3-75.3,75.3 C64.3,191.3,30.6,157.6,30.6,116"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M55.5,65.7C42.7,78.6,34.7,96.4,34.7,116c0,19.7,8,37.4,20.8,50.3c12.9,12.9,30.7,20.8,50.3,20.8 c19.7,0,37.4-8,50.3-20.8c12.9-12.9,20.8-30.7,20.8-50.3c0-19.7-8-37.4-20.8-50.3c-12.9-12.9-30.7-20.8-50.3-20.8 C86.2,44.9,68.4,52.8,55.5,65.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M173.6,116c0,37.4-30.3,67.8-67.8,67.8c-37.4,0-67.8-30.3-67.8-67.8c0-37.4,30.3-67.8,67.8-67.8 C143.3,48.3,173.6,78.6,173.6,116"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M157.9,116c0,28.7-23.3,52-52,52c-28.7,0-52-23.3-52-52c0-28.7,23.3-52,52-52C134.6,64,157.9,87.3,157.9,116 "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M111.5,165.9l-0.2-0.2l-2.5-2.7l-3.8-4.2c-1.9-2.1-5-4.8-6.7-6.2H36.4c-4.8,0-8.7-3.9-8.7-8.7 c0-3,1.6-5.9,4.2-7.4l15.3-10.9V93.5c-4.5-3.9-10-8.7-10.8-9.5c-1.4-1.5-2.1-3.5-2.1-5.6c0-4.6,3.7-8.4,8.3-8.4h53.5 c8.6,0,15.6,2.7,18.4,3.9c3.2-4.6,14.2-18.5,30.9-20.1c1.3-0.1,2.6-0.2,3.8-0.2c2.6,0,5.1,0.3,7.5,0.8c1,0.2,2,0.5,3,0.8 c13.9,4.4,22.7,17.4,22.4,33.1c-0.1,3.8-0.7,7.5-1.8,11c-2.8,8.7-6.8,15.4-12.6,21.3c-5.2,5.2-11.2,9-17.5,13 c-9.2,5.9-19.7,12.5-32.1,25.4l-4,4.1l-2.5,2.6L111.5,165.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M33.9,139.6c-1.5,0.9-2.4,2.4-2.4,4.3c0,2.7,2.2,4.9,4.9,4.9h63.2c2.2,1.8,5.8,4.9,8.1,7.4l3.8,4.2l3.9-4.1 c12.7-13.2,23.5-20,32.8-26c6.3-4,12-7.7,16.9-12.5c4.8-4.8,8.8-10.8,11.7-19.7c1.2-3.9,1.5-7.5,1.6-9.9 c0.3-13.9-7.5-25.5-19.8-29.4c-0.9-0.3-1.7-0.5-2.6-0.7c-3.2-0.7-6.7-0.9-10.2-0.5c-11.7,1.1-22.6,10-29,19.8l-1,1.5l-1.6-0.9 c0,0-7.7-4.2-18.1-4.2H42.6c-2.5,0-4.5,2.1-4.5,4.6c0,1.2,0.4,2.3,1.2,3.1c0.8,0.9,11.7,10.3,11.7,10.3v35.7L33.9,139.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M144.7,65.1c-12.9,1.3-23.7,13.7-27.3,23.3c0,0-7.5-8.4-18.4-7c-14.1,1.7-27.6,16-23.6,34.7 c4.8,18.8,20.2,17.3,36.3,34.9c30.1-31.2,49.9-27,57.9-55.5C173.2,78.6,162.7,63.3,144.7,65.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M46.2,80.1h35.5c0,0-14.8,8.5-14.8,30.5c0,22,22.2,32,22.2,32H39.5l17.5-11.8V89.5L46.2,80.1z"
}))))));
export { SvgLogo as ReactComponent };